"use client";
// src/components/home/HomeClientWrapper.jsx
import dynamic from "next/dynamic";

const HomeClient = dynamic(
  () => import("@/components/home/HomeClient"),
  { ssr: false }
);

export default function HomeClientWrapper({ initialContent }) {
  return <HomeClient initialContent={initialContent} />;
}